<template>
  <div class="container mescroll-touch">
    <div class="top">
      <div class="goPersonal" @click="$router.go(-1)">
        <img src="../../assets/images/icon_left1.png" />
        <span>个人中心</span>
      </div>
      <div class="tab">
        <div class="tab-item" :class="{'active': active == 'following'}" @click="tabChange('following')">
          <span class="chineseFont">关注</span>
          <span class="englishFont">Following</span>
        </div>
        <div class="tab-item" :class="{'active': active == 'followers'}" @click="tabChange('followers')">
          <span class="chineseFont">粉丝</span>
          <span class="englishFont">Followers</span>
        </div>
      </div>
    </div>
    <div class="searchBox">
      <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
      <input class="searchInput" type="text" v-model="searchValue" placeholder="请输入关键字搜索" @input="handleSearch" />
    </div>
    <div class="listBox">
      <template v-if="active == 'following'">
        <van-loading v-if="loading1" class="loading" type="spinner" size="26px" text-size="13px" vertical>加载中...</van-loading>
        <div class="list-item" v-for="(item, index) in FollowersList" :key="index">
          <div class="userIcon" @click="toPersonal(item.Id, item.Type)">
            <img v-if="item.Type != 2" src="@/assets/images/headSculpture1.png" alt="" />
            <img v-else src="@/assets/images/headSculpture2.png" alt="" />
          </div>
          <div class="userInfo">
            <div class="userInfo_top">
              <span class="userName">{{ item.UserName }}</span>
              <span class="positionalName" v-if="item.Type != 2">{{ item.PositionalName }}</span>
            </div>
            <div class="hospital" v-if="item.Type != 2">{{ item.HospitalTitle }}</div>
          </div>
          <template v-if="item.Type != 2">
            <div class="followBtn" v-if="item.State == 1" @click="followingUnFollow(index)">已关注</div>
            <div class="followBtn1" v-else @click="followingFollow(index)">
              <van-icon class="plusIcon" name="plus" />
              <span>关注</span>
            </div>
          </template>
        </div>
        <p class="noData" v-if="!loading1 && FollowersList.length == 0">暂无更多数据~</p>
      </template>
      <template v-else>
        <van-loading v-if="loading2" class="loading" type="spinner" size="26px" text-size="13px" vertical>加载中...</van-loading>
        <div class="list-item" v-for="(item, index) in FansList" :key="index">
          <div class="userIcon" @click="toPersonal(item.Id, item.Type)">
            <img v-if="item.Type != 2" src="@/assets/images/headSculpture1.png" alt="" />
            <img v-else src="@/assets/images/headSculpture2.png" alt="" />
          </div>
          <div class="userInfo">
            <div class="userInfo_top">
              <span class="userName">{{ item.UserName }}</span>
              <span class="positionalName" v-if="item.Type != 2">{{ item.PositionalName }}</span>
            </div>
            <div class="hospital" v-if="item.Type != 2">{{ item.HospitalTitle }}</div>
          </div>
          <template v-if="item.Type != 2">
            <div class="followBtn" v-if="item.State == 1" @click="followersUnFollow(index)">已关注</div>
            <div class="followBtn1" v-else @click="followersFollow(index)">
              <van-icon class="plusIcon" name="plus" />
              <span>关注</span>
            </div>
          </template>
        </div>
        <p class="noData" v-if="!loading2 && FansList.length == 0">暂无更多数据~</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FansFollowList',
  data() {
    return {
      active: 'following',
      searchValue: '',
      loading1: true,
      loading2: true,
      FansList: [],
      FollowersList: []
    }
  },
  created() {
    this.active = this.$route.query.type;
    this.getFansList();
    this.getFollowersList();
  },
  methods: {
    getFansList() {
      this.$axios.get('/Api/Api/Web/Customer/GetUFansList?name=' + this.searchValue).then(res => {
        this.loading2 = false;
        this.FansList = res.Data;
      })
    },
    getFollowersList() {
      this.$axios.get('/Api/Api/Web/Customer/GetUAttentionList?name=' + this.searchValue).then(res => {
        this.loading1 = false;
        this.FollowersList = res.Data;
      })
    },
    handleSearch() {
      if(this.active == 'following') {
        this.getFollowersList();
      } else {
        this.getFansList();
      }
    },
    tabChange(type) {
      if(this.active != type) {
        this.searchValue = '';
        this.active = type;
      }
      if(type == 'following') {
        this.getFollowersList();
      }
      if(type == 'followers') {
        this.getFansList();
      }
    },
    followingFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.FollowersList[index].Id).then((res) => {
        this.$set(this.FollowersList[index], 'State', 1);
      });
    },
    followingUnFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.FollowersList[index].Id).then((res) => {
        this.$set(this.FollowersList[index], 'State', 0);
      });
    },
    followersFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/AddUA?auid=' + this.FansList[index].Id).then((res) => {
        this.$set(this.FansList[index], 'State', 1);
      });
    },
    followersUnFollow(index) {
      this.$axios.post('/Api/Api/Web/Customer/UpdateUA?id=' + this.FansList[index].Id).then((res) => {
        this.$set(this.FansList[index], 'State', 0);
      });
    },
    toPersonal(id, type) {
      if(type != 2) {
        this.$router.push({
          path: 'Personal',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'JNJPersonal',
          query: {
            id: id
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  -webkit-text-size-adjust: none;
  background-color: #F9F8F7;
  box-sizing: border-box;
  .top {
    height: 110px;
    background-color: #EB1701;
    padding: 20px 25px 0;
    box-sizing: border-box;
    .goPersonal {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #FFFFFF;
      margin-top: 15px;
      img {
        display: block;
        width: 10px;
        margin-right: 6px;
      }
    }
    .tab {
      display: flex;
      margin-top: 10px;
      .tab-item {
        position: relative;
        flex: 1;
        text-align: center;
        color: #FFFFFF;
        span {
          display: block;
          line-height: 16px;
        }
        .chineseFont {
          font-size: 15px;
        }
        .englishFont {
          font-size: 11px;
        }
      }
      .active {
        font-weight: bold;
        .chineseFont {
          font-size: 16px;
        }
        .englishFont {
          font-size: 12px;
        }
      }
      .active::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-13px);
        width: 26px;
        height: 2px;
        background-color: #FFFFFF;
      }
    }
  }
  .searchBox {
    display: flex;
    align-items: center;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    background-color: #FFFFFF;
    padding: 0 15px;
    margin: 15px 15px 0;
    .searchIcon {
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }
    .searchInput {
      flex: 1;
      border: none;
      margin-right: 6px;
      background-color: transparent;
    }
  }
  .listBox {
    flex: 1;
    height: 0;
    overflow-y: auto;
    padding: 0 15px;
    .list-item {
      position: relative;
      display: flex;
      padding: 18px 0;
      color: #564C47;
      .userIcon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
        margin-right: 12px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .userInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .userName {
          font-size: 14px;
          font-weight: bold;
        }
        .positionalName {
          font-size: 10px;
          background-color: #EAEAEA;
          padding: 1px 2px;
          margin-left: 10px;
        }
        .hospital {
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .followBtn {
        position: absolute;
        top: 50%;
        right: 0;
        height: 18px;
        transform: translateY(-9px);
        line-height: 18px;
        font-size: 11px;
        background-color: #EAEAEA;
        padding: 0 6px;
      }
      .followBtn1 {
        position: absolute;
        top: 50%;
        right: 0;
        height: 18px;
        transform: translateY(-9px);
        line-height: 18px;
        font-size: 11px;
        background: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
        padding: 0 8px;
        border-radius: 2px;
        color: #FFFFFF;
        .plusIcon {
          font-size: 9px;
        }
      }
    }
    .list-item:not(:last-of-type) {
      background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
      background-size: 100% 1px;
      background-position: 0 100%;
      background-repeat: no-repeat;
    }
    .loading {
      margin: 30px 0;
    }
    .noData {
      margin: 30px 0;
      text-align: center;
      font-size: 12px;
      color: #969799;
    }
  }
}
</style>
